import React from 'react';
import { Icon } from './Icon.js';
export const IconQuickSearch = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 21L16.5 16.5L16.7806 16.7806", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("circle", { cx: "11", cy: "11", r: "8", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M10.1182 10H15.1182L12.1182 16H9.88184L11.8818 12H6.88184L9.88184 6H12.1182L10.1182 10Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconQuickSearch.js.map